exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".basic-card {\n  background-color: #FFFFFF;\n  height: 175px;\n  width: 33.33%;\n  border: 1px solid #CCCCCC;\n  border-radius: 3px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);\n  color: #003D50; }\n\n.basic-card-header {\n  height: 26px;\n  border: 1px solid #003D50;\n  border-radius: 3px 3px 0 0;\n  background-color: #003D50;\n  color: #FFFFFF; }\n\n.basic-card-header-text {\n  font-size: 11px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 26px;\n  margin: 0px;\n  padding-left: 20px; }\n\n.basic-card-content {\n  height: 95px;\n  overflow: hidden;\n  padding: 14px 20px; }\n\n.basic-card-title {\n  font-size: 16px;\n  font-weight: 300;\n  margin-bottom: 5px; }\n\n.basic-card-body {\n  font-size: 13px; }\n\n.basic-card-button-wrapper {\n  margin: 0 20px 20px 20px;\n  text-align: center; }\n\n.basic-card-button {\n  border-color: #5A5B5E;\n  color: #5A5B5E;\n  width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/widgets/basic-card.scss
// module id = 1210
// module chunks = 0